import { MapPin, ArrowRight, CircleCheck, CircleSlash } from "lucide-react";
import { BROWSE } from "../lib/testIds";

const CONDITION_LABEL = {
    new: "Brand new",
    "like-new": "Like new",
    good: "Good",
    fair: "Fair",
};

export const ItemCard = ({ item, onView }) => {
    const available = item.available !== false;
    return (
        <article
            data-testid={BROWSE.itemCard(item.id)}
            className="group flex flex-col overflow-hidden rounded-3xl border border-[#2e3220]/10 bg-[#F4F1EA] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_36px_rgba(46,50,32,0.10)]"
        >
            <div className="relative aspect-[4/3] w-full overflow-hidden bg-[#E8E2D0]">
                <img
                    src={item.image_url}
                    alt={item.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span
                    className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest ${
                        available
                            ? "bg-[#F4F1EA] text-[#737a3d]"
                            : "bg-[#2e3220] text-[#F4F1EA]"
                    }`}
                >
                    {available ? (
                        <>
                            <CircleCheck className="h-3 w-3" strokeWidth={2.5} />
                            Available
                        </>
                    ) : (
                        <>
                            <CircleSlash className="h-3 w-3" strokeWidth={2.5} />
                            Booked
                        </>
                    )}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-[#2e3220]/85 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-[#F4F1EA] backdrop-blur">
                    {item.category}
                </span>
            </div>

            <div className="flex flex-1 flex-col p-5">
                <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display text-lg font-bold leading-tight text-[#2e3220]">
                        {item.name}
                    </h3>
                    <div className="shrink-0 text-right">
                        <p className="font-display text-xl font-bold text-[#737a3d]">
                            ${item.price_per_day.toFixed(0)}
                        </p>
                        <p className="-mt-1 text-[10px] font-bold uppercase tracking-widest text-[#737a3d]/80">
                            per day
                        </p>
                    </div>
                </div>

                <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-[#5a6142]">
                    {item.location && (
                        <span className="inline-flex items-center gap-1">
                            <MapPin className="h-3.5 w-3.5" />
                            {item.location}
                        </span>
                    )}
                    <span className="inline-flex items-center gap-1">
                        <span className="h-1 w-1 rounded-full bg-[#5a6142]/50" />
                        {CONDITION_LABEL[item.condition] || item.condition}
                    </span>
                </div>

                <button
                    type="button"
                    data-testid={BROWSE.itemCardView(item.id)}
                    onClick={() => onView?.(item)}
                    className="mt-5 inline-flex items-center justify-center gap-1.5 self-start rounded-full bg-[#2e3220] px-5 py-2 text-sm font-bold text-[#F4F1EA] transition-all duration-200 hover:bg-[#3d4230]"
                >
                    View item
                    <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.5} />
                </button>
            </div>
        </article>
    );
};

export default ItemCard;
